import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d2e2b9fc")

_pushScopeId("data-v-d2e2b9fc")
const _hoisted_1 = { class: "text-muted" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("section", {
    class: ["module", [ _ctx.module.type ]]
  }, [
    _createVNode("nav", null, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.module.posts, (post) => {
        return (_openBlock(), _createBlock("div", null, [
          (post.postThumbnail)
            ? (_openBlock(), _createBlock("img", {
                key: 0,
                src: post.postThumbnail.url,
                alt: post.postThumbnail.imageDescription
              }, null, 8, ["src", "alt"]))
            : _createCommentVNode("", true),
          _createVNode("h3", null, _toDisplayString(post.title), 1),
          _createVNode("p", _hoisted_1, "Posted " + _toDisplayString(_ctx.postDate(post.date)), 1),
          _createVNode("a", {
            href: post.url,
            title: post.title,
            class: "btn"
          }, " See Post ", 8, ["href", "title"])
        ]))
      }), 256))
    ])
  ], 2))
})